import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs';
import { SharedFeaturesService } from 'src/app/services/shared-features.service';
import { SolutionsAppService } from 'src/app/services/solutions-app.service';
import { MatDialog } from '@angular/material/dialog';
import { ShowDialogsComponent } from 'src/app/components/show-dialogs/show-dialogs.component';
@Component({
  selector: 'app-configure-node',
  template: `
    <div class="d2c-node">
      <!-- Header card -->
      <div class="ehead">
        <button class="iconbtn" routerLink="../../" aria-label="Back">
          <svg
            viewBox="0 0 24 24"
            width="18"
            height="18"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M19 12H5M11 18l-6-6 6-6" />
          </svg>
        </button>
        <div class="mid">
          <h1 (click)="editable = !editable" class="title-edit">
            <span>
              {{
                pipelineName.pipeline_name_display &&
                pipelineName.pipeline_name_display !== 'pipeline_name_display'
                  ? (pipelineName.pipeline_name_display
                    | textpretty
                    | titlecase)
                  : (pipelineName.pipeline_name | textpretty | titlecase)
              }}
            </span>
            <svg
              class="edit-ico"
              viewBox="0 0 24 24"
              width="15"
              height="15"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 20h9" />
              <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
            </svg>
          </h1>
          <p>{{ pipelineName['pipeline_name'] | textpretty | titlecase }}</p>
          <div *ngIf="editable" class="rename-row">
            <label for="displayName">Customize Pipeline Name:</label>
            <input
              type="text"
              id="displayName"
              matInput
              [(ngModel)]="displayName"
            />
          </div>
        </div>
        <div class="acts">
          <button
            class="btn-ghost"
            (click)="runPipelineById(pipelineName.pipeline_id)"
          >
            <svg
              viewBox="0 0 24 24"
              width="15"
              height="15"
              fill="currentColor"
              stroke="none"
            >
              <path d="M8 5v14l11-7z" />
            </svg>
            {{ checkedNodeIdList.length > 0 ? 'Run Selected' : 'Run All' }}
          </button>
          <button class="btn-primary" (click)="updatePipeline()">
            <svg
              viewBox="0 0 24 24"
              width="15"
              height="15"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2Z"
              />
              <path d="M17 21v-8H7v8M7 3v5h8" />
            </svg>
            Save
          </button>
        </div>
      </div>

      <div class="panes">
        <!-- LEFT: Steps -->
        <div class="pane">
          <div class="ph">Steps</div>
          <div class="pb">
            <div class="addbar">
              <mat-form-field appearance="fill" class="addbar-field">
                <mat-label>Select Steps</mat-label>
                <mat-select [(ngModel)]="selectedValue" name="food">
                  <mat-option
                    *ngFor="let value of stepsInPipeline"
                    [value]="value"
                  >
                    {{ value | textpretty | titlecase }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <button
                class="btn-primary addbar-btn"
                [disabled]="!selectedValue"
                (click)="onSelect()"
                aria-label="Add"
              >
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M12 5v14M5 12h14" />
                </svg>
              </button>
            </div>

            <!-- Configured Nodes in the pipeline -->
            <div class="flow">
              <div
                *ngFor="let pipeN of configuredStepsInPipeline; let idx = index"
                class="fitem"
                [ngClass]="{
                  sel: pipeN.node_id == selectedNodeId,
                  err: pipeN.node_id == nodeIdofIncorrectNode
                }"
                (mouseenter)="showInputOutputInfo(pipeN)"
                (mouseleave)="hideInputOutputInfo()"
              >
                <mat-checkbox
                  class="frow-cbx"
                  (change)="addCheckedNodes($event, pipeN.node_id)"
                ></mat-checkbox>
                <span class="fnum">{{ idx + 1 }}</span>
                <span class="fname">{{
                  pipeN['node_name'] | textpretty | titlecase
                }}</span>
                <span class="fact">
                  <button
                    class="iconbtn sm"
                    (click)="editNode(pipeN)"
                    aria-label="Edit"
                  >
                    <svg
                      viewBox="0 0 24 24"
                      width="15"
                      height="15"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M12 20h9" />
                      <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
                    </svg>
                  </button>
                  <button
                    class="iconbtn sm danger"
                    (click)="deleteNode(pipeN['node_id'])"
                    aria-label="Delete"
                  >
                    <svg
                      viewBox="0 0 24 24"
                      width="15"
                      height="15"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M3 6h18" />
                      <path d="M8 6V4h8v2" />
                      <path d="M6 6l1 14h10l1-14" />
                    </svg>
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- RIGHT: editor / read-only summary -->
        <div class="right-pane">
          <!-- Read-only hover summary -->
          <div *ngIf="InputOutputInfo">
            <div class="ccard">
              <div class="ch">
                <span class="ic ci-in">
                  <svg
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M19 12H5M11 18l-6-6 6-6" />
                  </svg>
                </span>
                Inputs
              </div>
              <div class="cb">
                <div
                  class="ioline"
                  *ngFor="let item of NodeInfo.node_config.input"
                >
                  <span class="k">Table Name:</span>
                  <span class="v">{{ item[0] }}</span>
                  <span class="k">From:</span>
                  <span class="v">{{ item[1] }}</span>
                </div>
              </div>
            </div>
            <div class="ccard">
              <div class="ch">
                <span class="ic ci-out">
                  <svg
                    viewBox="0 0 24 24"
                    width="15"
                    height="15"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2Z"
                    />
                    <path d="M17 21v-8H7v8M7 3v5h8" />
                  </svg>
                </span>
                Outputs
              </div>
              <div class="cb">
                <div
                  class="ioline"
                  *ngFor="let item of NodeInfo.node_config.output"
                >
                  <span class="k">Table Name:</span>
                  <span class="v">{{ item[0] }}</span>
                  <span class="k">Save To:</span>
                  <span class="v">{{ item[1] }}</span>
                </div>
              </div>
            </div>
            <div class="ccard">
              <div class="ch">
                <span class="ic ci-tag">
                  <svg
                    viewBox="0 0 24 24"
                    width="15"
                    height="15"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                    />
                    <path d="M14 2v6h6" />
                    <path d="M8 13h8M8 17h5" />
                  </svg>
                </span>
                Tags
              </div>
              <div class="cb">
                <span class="chip" *ngFor="let item of NodeInfo.tags">{{
                  item
                }}</span>
              </div>
            </div>
          </div>

          <!-- Editor block -->
          <div>
            <div
              *ngIf="selectedNode && !InputOutputInfo"
              class="ccard tags-card"
            >
              <div class="ch">
                <span class="ic ci-tag">
                  <svg
                    viewBox="0 0 24 24"
                    width="15"
                    height="15"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                    />
                    <path d="M14 2v6h6" />
                    <path d="M8 13h8M8 17h5" />
                  </svg>
                </span>
                Tags
              </div>
              <div class="cb">
                <mat-form-field class="example-full-width">
                  <mat-label>Enter Tag(s)</mat-label>
                  <input
                    matInput
                    placeholder="tag1,tag2"
                    [(ngModel)]="node_tags"
                  />
                </mat-form-field>
              </div>
            </div>
            <app-form-builder-secondary
              *ngIf="selectedNode && !InputOutputInfo"
              [nodePayLoad]="selectedNode"
              (outputData)="getOutput($event)"
            ></app-form-builder-secondary>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./configure-node.component.scss'],
})
export class ConfigureNodeComponent implements OnInit {
  editable: boolean = false;
  displayName: string = '';
  pipelineName: any = {
    pipeline_id: -1,
    pipeline_name: '',
    project_id: 1,
    pipeline_name_display: '',
    created_dtm: '',
    is_active: true,
  };
  stepsInPipeline = [];
  Nodes = [
    {
      nodeName: {
        args: {},
        input: {},
        output: {},
      },
    },
  ];
  selectedNode: any = false;
  configuredStepsInPipeline: any = [];
  selectedValue = '';
  selectedUpdateNode: any;
  selectedNodeId: any;
  updateNode: boolean = false;
  InputOutputInfo: boolean = false;
  NodeInfo: any;
  checkedNodeIdList: number[] = [];
  nodeIdofIncorrectNode: any;
  node_tags: string = '';
  activeProject: any;
  activePipeline: any;
  solutionId: any = '';
  versionId: any = '';
  constructor(
    private solutionServices: SolutionsAppService,
    private snackBar: SharedFeaturesService,
    private changeDetectorRef: ChangeDetectorRef,
    private sharedServices: SharedFeaturesService,
    private route: ActivatedRoute,
    private dialog: MatDialog
  ) {}
  ngOnInit() {
    const pipelineId: any = this.route.snapshot.paramMap.get('pipelineId');
    this.route.parent?.params
      .pipe(map((params: any) => params))
      .subscribe((parentParams) => {
        this.solutionId = parentParams.solutionId;
        this.versionId = parentParams.versionId;
        this.activeProject = parentParams.projectId;
        this.solutionServices
          .getPipeline(
            { solution_id: this.solutionId },
            { version_id: this.versionId },
            this.activeProject,
            pipelineId
          )
          .subscribe({
            next: (response: any) => {
              this.pipelineName = response;
              this.displayName = this.pipelineName['pipeline_name_display'];
              this.solutionServices
                .getavailableNodes(this.pipelineName['pipeline_name'])
                .subscribe((result: any) => {
                  this.Nodes = result;
                  this.stepsInPipeline = result.map(
                    (obj: any) => Object.keys(obj)[0]
                  );
                });
              this.getConfiguredStepsInPipeline();
            },
            error: (error) => {
              console.error('an error occurred', error);
            },
          });
      });

    this.solutionServices.setMyVariable([]);
  }

  showInputOutputInfo(data: any) {
    this.InputOutputInfo = true;
    this.NodeInfo = data;
  }
  hideInputOutputInfo() {
    this.InputOutputInfo = false;
  }

  addCheckedNodes(event: any, id: number) {
    this.checkedNodeIdList = this.checkedNodeIdList.filter(
      (element) => element !== id
    );
    if (event.checked) {
      this.checkedNodeIdList.push(id);
    }
  }
  getConfiguredStepsInPipeline() {
    this.solutionServices
      .getConfiguredNodesInPipeline(
        { solution_id: this.solutionId },
        { version_id: this.versionId },
        this.activeProject,
        this.pipelineName['pipeline_id']
      )
      .subscribe((result: any) => {
        this.configuredStepsInPipeline = result.reverse();
      });
  }

  onSelect() {
    this.node_tags = '';
    this.updateNode = false;
    this.selectedNode = false;
    this.selectedNodeId = false;
    this.changeDetectorRef.detectChanges();
    let temp = this.getObjectByKey(this.Nodes, this.selectedValue);
    this.selectedNode = temp[this.selectedValue];
    this.getConfiguredStepsInPipeline();
    this.changeDetectorRef.detectChanges();
  }

  getObjectByKey(objects: any, keyToFind: string) {
    return objects.find((obj: any) => Object.keys(obj)[0] === keyToFind);
  }

  getOutput(data: any) {
    let temp = {
      node_name: '',
      node_config: {},
      is_active: true,
      tags: this.sharedServices.splitAndTrim(this.node_tags),
    };
    temp.node_name = this.selectedValue;
    temp.node_config = data;
    if (!this.updateNode) {
      this.solutionServices
        .configureNode(
          { solution_id: this.solutionId },
          { version_id: this.versionId },
          this.activeProject,
          this.pipelineName['pipeline_id'],
          temp
        )
        .subscribe({
          next: (response: any) => {
            this.snackBar.openSnackBar(
              'node created successfully',
              'Close',
              'success-snackbar'
            );
            this.getConfiguredStepsInPipeline();
          },
          error: (error: any) => {
            this.snackBar.openSnackBar(
              this.snackBar.convertErrorToString(error?.error),
              'Close',
              'error-snackbar'
            );
          },
        });
    } else {
      this.solutionServices
        .updateNode(
          { solution_id: this.solutionId },
          { version_id: this.versionId },
          this.activeProject,
          this.pipelineName['pipeline_id'],
          this.selectedUpdateNode.node_id,
          temp
        )
        .subscribe({
          next: (response: any) => {
            this.snackBar.openSnackBar(
              'node updated successfully',
              'Close',
              'success-snackbar'
            );
            this.getConfiguredStepsInPipeline();
          },
          error: (error: any) => {
            this.snackBar.openSnackBar(
              this.snackBar.convertErrorToString(error?.error),
              'Close',
              'error-snackbar'
            );
          },
        });
    }
  }

  deleteNode(nodeId: string) {
    const ref = this.dialog.open(ShowDialogsComponent, {
      data: {
        title: 'Delete this step?',
        message:
          'This removes the step from the pipeline. This action cannot be undone.',
        confirmText: 'Delete',
        cancelText: 'Cancel',
        danger: true,
      },
      disableClose: false,
    });
    ref.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.doDeleteNode(nodeId);
      }
    });
  }

  private doDeleteNode(nodeId: string) {
    this.solutionServices
      .deleteNode(
        { solution_id: this.solutionId },
        { version_id: this.versionId },
        this.activeProject,
        this.pipelineName['pipeline_id'],
        nodeId
      )
      .subscribe({
        next: (result: any) => {
          this.getConfiguredStepsInPipeline();
          this.snackBar.openSnackBar(
            'node deleted successfully',
            'Close',
            'success-snackbar'
          );
        },
        error: (error) => {
          this.snackBar.openSnackBar(
            this.snackBar.convertErrorToString(error?.error),
            'Close',
            'error-snackbar'
          );
        },
      });
  }

  editNode(node: any) {
    this.node_tags = '';
    this.selectedUpdateNode = node;
    this.node_tags = this.sharedServices.joinToString(node['tags']);
    this.selectedNode = false;
    this.updateNode = true;
    this.changeDetectorRef.detectChanges();
    this.selectedValue = node.node_name;
    this.selectedNode = node.node_config;
    this.selectedNodeId = node.node_id;
    this.changeDetectorRef.detectChanges();
  }

  updatePipeline() {
    let pipelineObject = {
      pipeline_name: this.pipelineName.pipeline_name,
      pipeline_name_display: this.displayName,
    };
    this.solutionServices
      .update_pipeline(
        { solution_id: this.solutionId },
        { version_id: this.versionId },
        this.activeProject,
        this.pipelineName.pipeline_id,
        pipelineObject
      )
      .subscribe({
        next: (response: any) => {
          this.snackBar.openSnackBar(
            'pipeline updated successfully',
            'Close',
            'success-snackbar'
          );
          this.pipelineName.pipeline_name_display = this.displayName;
          this.editable = false;
          this.changeDetectorRef.detectChanges();
        },
        error: (error: any) => {
          this.snackBar.openSnackBar(
            this.snackBar.convertErrorToString(error?.error),
            'Close',
            'error-snackbar'
          );
        },
      });
  }

  runPipelineById(pipelineId: string) {
    this.snackBar.openSnackBar(
      'Pipeline is running...',
      'Close',
      'progress-snackbar'
    );
    let temp: any = {
      project_ids: [],
      pipeline_ids: this.checkedNodeIdList.length > 0 ? [] : [pipelineId],
      node_ids: this.checkedNodeIdList.length > 0 ? this.checkedNodeIdList : [],
      tags: [],
    };

    this.solutionServices
      .runVersionOrProjectOrPipelineOrNode(
        this.solutionId,
        this.versionId,
        temp
      )
      .subscribe({
        next: (response: any) => {
          this.snackBar.openSnackBar(
            `Run queued${response?.task_id ? ` (task #${String(response.task_id).slice(0, 8)})` : ''} — we'll let you know when it finishes.`,
            'Close',
            'success-snackbar'
          );
        },
        error: (error) => {
          try {
            this.nodeIdofIncorrectNode = parseInt(
              this.snackBar.extractNodeId(error.error.error)['nodeId']
            );
          } catch {
            this.nodeIdofIncorrectNode = null;
          }
          this.snackBar.openSnackBar(
            error.error.error,
            'Close',
            'error-snackbar'
          );
        },
      });
  }
}
